"use strict";
const jQuery = require('jquery');
window.jQuery = window.$ = $ = jQuery;

import '../../../node_modules/owl.carousel/dist/owl.carousel.js';

const banner = () => {
	return {
		init(selector){
			const banner = $(`${selector}__carousel`).owlCarousel({
				dots: true,
				nav: false,
				loop: true,
				items: 1,
				dotsData: true
			});

			$(`${selector}__control--next`).click(()=>{
				banner.trigger('next.owl.carousel');
			});

			$(`${selector}__control--prev`).click(()=>{
				banner.trigger('prev.owl.carousel');
			});
		}
	}
}

export default banner;